export { DELAY_MS_HIDE, DELAY_MS_SHOW } from '../../util/config';

export { ProfileCardLazy } from './lazyProfileCard';
import ProfileCardTrigger from './ProfileCardTrigger';

export default ProfileCardTrigger;
